import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { clientActions } from '../../../../store';

import type { AppDispatch } from '../../../../store';
import type { UseSelectedClientDetailsLoaderParams } from './types';

export const useSelectedClientDetailsLoader = ({
  clients,
  providerAssignments,
  getAccessTokenSilently,
}: UseSelectedClientDetailsLoaderParams) => {
  const dispatch = useDispatch<AppDispatch>();

  return useCallback(
    (clientId: number | null) => {
      if (!clientId) {
        dispatch(clientActions.clearSelectedClient());
        return;
      }

      const client =
        clients.find((item) => item.id === clientId) ??
        providerAssignments.find((assignment) => assignment.client?.id === clientId)?.client;

      if (client) {
        dispatch(clientActions.setSelected(client));
      }

      dispatch(clientActions.getSelectedClientDetails({ clientId, getAccessTokenSilently }));
    },
    [clients, dispatch, getAccessTokenSilently, providerAssignments],
  );
};
